import apiFetch from '../../apiFetch'

export default function (token, saleId, orderId, dossierSubTypeId, lastAccessDate) {
  return apiFetch({ endPoint: `dossier/purchase/reassignToSale/${saleId}?orderId=${orderId}&dossierSubtypeId=${dossierSubTypeId}`, method: 'PUT', body: null, token: token, lastAccessDate })
}
